export default __webpack_public_path__ + "static/steam_w.a4f1df259f9bdc751a6e9059da4d480f.png";